import { httpClient } from "../http/httpClient";
import { GenerateOffersResponse } from "../panService/generateOffers";

export interface GenerateOffersPanPayload {
  cpf: string;
  prazo: number;
  valor: number;
  renda?: number;
  proposalId?: string;
}

export async function generateOffersPan(
  linkName: string,
  payload: GenerateOffersPanPayload,
): Promise<GenerateOffersResponse> {
  const { data } = await httpClient
    .patch<GenerateOffersResponse>(`/self-hire/${linkName}/simulate`, {
      type: "PAN",
      cpf: payload.cpf,
      prazo: payload.prazo,
      providerData: {
        valor: payload.valor,
        renda: payload.renda,
        proposalId: payload.proposalId,
      },
    })
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
